export const GET_ORACLE_LIST = 'GET_ORACLE_LIST'
